import React from "react";
import { MdClose, MdFilterList, MdRefresh } from "react-icons/md";
import { elakayAutoText } from "../../includes/pageInside/dataElakay";
import "../../includes/pageInside/Filters.css";

// The visual shell of every Elakay filter drawer: ELAKAY eyebrow + title header with Close, the
// Portrait / Landscape toggle, a scrolling body and the Clear All footer -- the exact markup and
// classes of the Buyer "Filters" drawer (Filter_fitlerP), so Buyer, Provider Filters, Filters Shop and
// Filter Products share ONE look while their sections (children) differ per context.
// embedded=true: the panel is a SECTION of the single "Elakay Navigation" drawer -- no header of its own
// (no second title bar / Close), just Portrait-Landscape, the accordions and Clear All.
export default function ElakayFilterShell({ title, icon: Icon = MdFilterList, click, gridButon, onClear, clearLabel, children, bodyClassName = "", embedded = false }) {
  return (
    <div className={`SideDrawer1-filters-container-modern${embedded ? " drawer1-embedded" : ""}`}>
      {!embedded && <div className="SideDrawer1-filters-header">
        <div className="SideDrawer1-filters-header-content">
          <div className="SideDrawer1-filters-icon-wrapper"><Icon className="SideDrawer1-filters-icon" /></div>
          <div>
            <span className="SideDrawer1-filters-eyebrow">ELAKAY</span>
            <h3 className="SideDrawer1-filters-title">{title}</h3>
          </div>
        </div>
        <button type="button" className="SideDrawer1-filters-close-btn" onClick={click} aria-label={elakayAutoText("h_c2db1e0ed9c89b", "Close filters")}><MdClose /></button>
      </div>}
      {gridButon && gridButon()}
      <div className={`SideDrawer1-filters-body ${bodyClassName}`}>{children}</div>
      {onClear && (
        <div className="SideDrawer1-filters-footer">
          <button type="button" className="SideDrawer1-clear-filters-btn" onClick={onClear}>
            <MdRefresh className="SideDrawer1-clear-icon" /><span>{clearLabel || elakayAutoText("h_pff_clear", "Clear All")}</span>
          </button>
        </div>
      )}
    </div>
  );
}
